import { createSelector, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../store";
import { EnumData, EnumForm } from "../model/Enum";

export const enumFormTitle = {
    OrganizationType: "Organization Type",
    ContactGroup: "Contact Group",
    BusinessCategory: "Business Categorie",
};

export const enumFormType = {
    OrganizationType: "OrganizationType",
    ContactGroup: "ContactGroup",
    BusinessCategory: "BusinessCategory",
};

export const initialEnumFormState = {
    form: {
        title: "",
        open: false,
        enumData: {
            id: 0,
            name: "",
            type: "",
        } as EnumData,
    } as EnumForm,
};
export const enumFormSlice = createSlice({
    name: "enumForm",
    initialState: initialEnumFormState,
    reducers: {
        onChangeType: (state, action): void => {
            state.form.enumData.type = action.payload;
        },
        onChangeName: (state, action): void => {
            state.form.enumData.name = action.payload;
        },
        onOpenDialog: (state, action): void => {
            state.form = {
                ...action.payload.form,
                enumData: {
                    ...action.payload.form.enumData,
                    type: action.payload.form.enumData.type
                        ? action.payload.form.enumData.type
                        : state.form.enumData.type,
                },
            };
        },
    },
});

// Actions
export const { onChangeType, onChangeName, onOpenDialog } = enumFormSlice.actions;

// Selectors
export const formSelector = createSelector(
    (state: RootState): EnumForm => state.enumForm.form,
    (form: EnumForm): EnumForm => form
);
